<div class="company-list-content">
  <!-- Enquanto a primeira resposta não chega, esqueleto; antes caía no "Nenhuma empresa encontrada". -->
  <app-table-skeleton
    *ngIf="!loaded"
    [rowCount]="pagination.itemsPerPage || 10"
    [columnWidths]="[1.4, 3.4, 2.6, 3.4, 1.8, 2.4, 1.9]"
    [showToolbar]="true"
    class="company-list-content__skeleton" />
  <div *ngIf="loaded && formatedGroupList.length; else noGroupList">
    <app-table
      #table
      [items]="formatedGroupList"
      [deleteTitle]="tk.Management.CompanyDeleteConfirmationTitle | t"
      [columnDefinitions]="columnDefinitions"
      [totalRecords]="pagination.total"
      [options]="tableOptions"
      [getOptionsFunction]="getMenuActions.bind(this)"
      [rows]="pagination.itemsPerPage || 10"
      [permissions]="customerPermissions"
      [hasCheckbox]="selectable"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"
      (sendTableSelection)="handleTableSelection($event)">
      <!-- PBI 3576: empresa cadastrada pelo Cog a partir de um documento do Data Room ganha etiqueta. -->
      <ng-template appNamedTemplate="corporateName" let-item>
        <span class="company-name" [attr.data-value]="item.corporateName">
          {{ item.corporateName }}
          @if (item.registrationSource === 'CogDataRoom') {
            <span
              class="company-cog-tag"
              [class.company-cog-tag--pending]="!item.registrationReviewedAt"
              [title]="
                item.registrationReviewedAt
                  ? 'Cadastrada pelo Cog a partir de um documento do Data Room e já conferida'
                  : 'Cadastrada pelo Cog a partir de um documento do Data Room. Abra a empresa para conferir e confirmar o cadastro.'
              ">
              <i class="pi pi-sparkles" aria-hidden="true"></i>
              Cadastrada pelo Cog{{ item.registrationReviewedAt ? '' : ', a conferir' }}
            </span>
          }
        </span>
      </ng-template>
      <!-- Situação comercial (card 3072): prospect de deal x cliente de fato -->
      <ng-template appNamedTemplate="commercialStatus" let-item>
        <span
          class="company-status"
          [class.company-status--prospect]="item.commercialStatus === 'Prospect'"
          [attr.data-value]="item.commercialStatus === 'Prospect' ? 'Prospect' : 'Cliente'">
          {{ item.commercialStatus === 'Prospect' ? 'Prospect' : 'Cliente' }}
        </span>
      </ng-template>
      <!-- Setor padronizado (card 3642) -->
      <ng-template appNamedTemplate="companySectorName" let-item>
        <span [attr.data-value]="item.companySectorName || 'Sem setor'">
          @if (item.companySectorName) {
            {{ item.companySectorName }}
          } @else {
            <span class="company-muted">Sem setor</span>
          }
        </span>
      </ng-template>
      <ng-template appNamedTemplate="commercialPartnerName" let-item>
        <span [attr.data-value]="item.commercialPartnerName || '—'">
          {{ item.commercialPartnerName || '—' }}
        </span>
      </ng-template>
      <!-- Template customizado para progress com barra visual e valor para exportação -->
      <ng-template appNamedTemplate="progress" let-item>
        <span
          [attr.data-value]="(item.progress || 0) + '%'"
          [attr.title]="(item.progress || 0) + '%'">
          <app-progress-bar
            [percentage]="item.progress || 0"
            [showValue]="false"
            [label]="''"
            [hasCap]="false"></app-progress-bar>
        </span>
      </ng-template>
    </app-table>
  </div>
  <ng-template #noGroupList>
    <div *ngIf="loaded" class="company-list-content__empty">
      <h4>{{ tk.Market.NoCompanyFound | t }}</h4>

      <div
        class="company-list-content__empty__button"
        *appHasPermission="customerPermissions.CREATE">
        <app-button
          [id]="'add-group'"
          [label]="tk.User.ToAdd | t"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addCompany()"></app-button>
      </div>
    </div>
  </ng-template>
</div>
<app-dialog
  [key]="'select-user-to-onboarding'"
  [action]="'select-user-to-onboarding'"
  [headerTheme]="'none'"
  [title]="(tk.Onboarding.ChooseUserToSendOnboardingLink | t) || ''">
  <div *ngIf="!users?.length" class="user-to-send__error">
    <app-simple-messages
      [text]="tk.General.NoUserRegisteredForSelectedCompany | t"
      severity="info" />
  </div>

  <div *ngIf="users?.length" class="user-to-send">
    <div *ngFor="let user of users" class="user-to-send__item">
      <app-user-data-h
        [name]="user.firstName + ' ' + user.surName"
        [email]="user.email"
        [infoContainer]="'row'"
        [action]="{
          action: 'send-onboarding-link',
          label: (tk.Onboarding.SendLink | t) || '',
        }"
        (sendAction)="handleSendAction($event, user)"></app-user-data-h>
    </div>
  </div>
</app-dialog>

<app-dialog
  [key]="'user-to-onboarding-success'"
  [action]="'user-to-onboarding-success'"
  [headerTheme]="'none'"
  [title]="tk.Onboarding.registrationCompleted | t"
  [breakpoints]="{
    '960px': '25vw',
    '768px': '95vw',
    '640px': '98vw',
    '480px': '100vw',
  }">
</app-dialog>

<app-company-contacts-modal #modalCompanyContacts></app-company-contacts-modal>
<app-modal-bank-contacts #modalBankContacts></app-modal-bank-contacts>
<app-onboarding-v2-view-modal #modalOnboardingView></app-onboarding-v2-view-modal>
